export default __webpack_public_path__ + "08e78e5.png";